import { Facebook, Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { assets, contact, navigation } from "../content/siteContent";

export function SiteFooter() {
  return (
    <footer className="site-footer technical-frame">
      <div className="footer-grid">
        <Link className="footer-brand" to="/" aria-label="ΑΣΟ Ωμέγα — Αρχική">
          <img src={assets.logo} alt="Λογότυπο ΑΣΟ Ωμέγα" />
        </Link>

        <div className="footer-contact" aria-label="Στοιχεία επικοινωνίας">
          <div className="footer-contact-row">
            <Facebook aria-hidden="true" />
            <a href={contact.facebook} target="_blank" rel="noreferrer" data-target>
              {contact.facebook}
            </a>
          </div>
          <div className="footer-contact-row">
            <Mail aria-hidden="true" />
            <a href={`mailto:${contact.email}`} data-target>
              {contact.email}
            </a>
          </div>
          <div className="footer-contact-row">
            <Phone aria-hidden="true" />
            <a href={`tel:${contact.phone.replace(/\s/g, "")}`} data-target>
              {contact.phone}
            </a>
          </div>
        </div>

        <nav className="footer-nav" aria-label="Πλοήγηση υποσέλιδου">
          {navigation.map((item) => (
            <Link key={item.path} to={item.path}>
              {item.label}
            </Link>
          ))}
        </nav>
      </div>
      <div className="footer-base">
        <span>ΑΣΟ ΩΜΕΓΑ</span>
        <span>© {new Date().getFullYear()}</span>
      </div>
    </footer>
  );
}
